export class KafkaSecretProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "credentialsProfileId",
            "baseName": "credentialsProfileId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "security",
            "baseName": "security",
            "type": "KafkaSecurityConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return KafkaSecretProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
